import { PATIENT_OVERVIEW_EDIT_WINDOW } from "../../../store/PatientInformationForm/type";
import * as React from "react";
import { PatientEditPopup } from "../../genericComponents/PatientEditPopup";
import { EmailsEditContainer } from "../EditComponents/EmailsEditContainer";
import { DemographicsEdit } from "../EditComponents/DemographicsEdit";
import { IPatientOverviewProps } from "../Types";
import { PhonesEditContainer } from "../EditComponents/PhonesEditContainer";
import { HealthCardCheckin, PreferredPharmacyCheckin } from "../../../dtos/KioskDtos.dtos";
import { AddressesEditContainer } from "../EditComponents/AddressesEditContainer";
import { PreferredPharmacyEdit } from "../EditComponents/PreferredPharmacyEdit";

export const elementEditPopupTemplate = (hidePopupFunction: () => void, title: string, showPatientInfoEditModal: boolean, child: JSX.Element, onClick: (e) => void): JSX.Element => {
    return (
        <PatientEditPopup
            visible={showPatientInfoEditModal}
            hidepopup={hidePopupFunction}
            title={title}
            largeSize={"true"}
            onClick={onClick}
        >
            <div style={{ textAlign: "left" }}>
                {child}
            </div>
        </PatientEditPopup>
    );
}

export const AppropriateEditPopup = (props: IPatientOverviewProps): JSX.Element => {
    const hideKeyboard = () => props.isKeyboardActive ? props.hideKeyboard() : null;
    const hideEditModal = (value: PATIENT_OVERVIEW_EDIT_WINDOW) => () => props.showEditModal(false, value);
    switch (props.patientEditPopupSelected) {
        case PATIENT_OVERVIEW_EDIT_WINDOW.ADDRESS:
            return elementEditPopupTemplate(
                hideEditModal(PATIENT_OVERVIEW_EDIT_WINDOW.ADDRESS),
                props.text.titles.AddressTitle,
                props.showPatientInfoEditModal,
                (
                    <AddressesEditContainer
                        lang={props.lang}
                        contactPointOptions={props.emailContactPointOptions}
                        countryMappedStrings={props.countryMappedStrings}
                        countryList={props.countryList}
                        stateList={props.stateList}
                        saveAddresses={props.saveAddress}
                        defaultCountryAndState={{ country: props.defaultCountry, region: props.defaultRegion }}
                        cancel={hideEditModal(PATIENT_OVERVIEW_EDIT_WINDOW.ADDRESS)}
                        addresses={props.patientInfo.addresses}
                        text={props.text}
                        onFocus={(pipe: (value: any) => void, value, mask: string, id: string) => props.showKeyboard(pipe, value, mask, id)}
                        focusedInputName={props.keyboardFocusedName}
                        disconnectKeyboard={props.hideKeyboard}
                    />
                ),
                hideKeyboard
            );
        case PATIENT_OVERVIEW_EDIT_WINDOW.PHONE:
            let defaultCountry = props.defaultCountry;
            if (!props.patientInfo.addresses.isEmpty()) {
                const preferredAddress = props.patientInfo.addresses.firstOrDefault(x => x.isPreferred)
                if (preferredAddress) {
                    defaultCountry = preferredAddress.country;
                }
            }

            return elementEditPopupTemplate(
                hideEditModal(PATIENT_OVERVIEW_EDIT_WINDOW.PHONE),
                props.text.titles.PhoneTitle,
                props.showPatientInfoEditModal,
                (
                    <PhonesEditContainer
                        savePhones={props.savePhones}
                        phoneTypesOptions={props.phoneTypesOptions}
                        cancel={hideEditModal(PATIENT_OVERVIEW_EDIT_WINDOW.PHONE)}
                        defaultCountry={defaultCountry}
                        countryList={props.countryList}
                        text={props.text}
                        phones={props.patientInfo.phones}
                        onFocus={(pipe: (value: any) => void, value, mask: string, id: string) => props.showPhoneKeyboard(pipe, value, mask, id)}
                        focusedInputName={props.keyboardFocusedName}
                        disconnectKeyboard={props.hideKeyboard}
                        myleClinicSettings={props.myleClinicSettings}
                    />
                ),
                hideKeyboard
            );
        case PATIENT_OVERVIEW_EDIT_WINDOW.EMAIL:
            return elementEditPopupTemplate(
                hideEditModal(PATIENT_OVERVIEW_EDIT_WINDOW.EMAIL),
                props.text.titles.EmailTitle,
                props.showPatientInfoEditModal,
                (
                    <EmailsEditContainer
                        emailContactPointOptions={props.emailContactPointOptions}
                        saveEmails={props.saveEmails}
                        cancel={hideEditModal(PATIENT_OVERVIEW_EDIT_WINDOW.EMAIL)}
                        emails={props.patientInfo.emails}
                        text={props.text}
                        onFocus={(pipe: (value: any) => void, value, mask: string, id: string) => props.showKeyboard(pipe, value, mask, id)}
                        focusedInputName={props.keyboardFocusedName}
                        disconnectKeyboard={props.hideKeyboard}
                        myleClinicSettings={props.myleClinicSettings}
                    />
                ),
                hideKeyboard
            );
        case PATIENT_OVERVIEW_EDIT_WINDOW.DEMOGRAPHICS:
            return elementEditPopupTemplate(
                hideEditModal(PATIENT_OVERVIEW_EDIT_WINDOW.DEMOGRAPHICS),
                props.text.titles.DemographicsTitle,
                props.showPatientInfoEditModal,
                (
                    <DemographicsEdit
                        listNotToRender={""}
                        lang={props.lang}
                        save={(healthCard:HealthCardCheckin) =>  props.saveDemographicsAndHealthCard(props.patientInfo.demographics, healthCard)}
                        cancel={() => { props.showEditModal(false, PATIENT_OVERVIEW_EDIT_WINDOW.DEMOGRAPHICS) }}
                        demographics={props.patientInfo.demographics}
                        healthCard={props.patientInfo.healthCard}
                        prefixOptions={props.prefixOptions}
                        countryMappedStrings={props.countryMappedStrings}
                        text={props.text}
                        showDatePicker={props.showDatePicker}
                        focusedInputName={props.keyboardFocusedName}
                    />
                ),
                hideKeyboard
            );
        case PATIENT_OVERVIEW_EDIT_WINDOW.PREFERRED_PHARMACY:
            return elementEditPopupTemplate(
                hideEditModal(PATIENT_OVERVIEW_EDIT_WINDOW.PREFERRED_PHARMACY),
                props.text.titles.PreferredPharmacyTitle,
                props.showPatientInfoEditModal,
                (
                    <PreferredPharmacyEdit
                        lang={props.lang}
                        text={props.text}
                        preferredPharmacy={props.patientInfo.preferredPharmacy}
                        save={(preferredPharmacy:PreferredPharmacyCheckin) =>  props.savePreferredPharmacy(preferredPharmacy)}
                        cancel={() => { props.showEditModal(false, PATIENT_OVERVIEW_EDIT_WINDOW.PREFERRED_PHARMACY) }}
                        focusedInputName={props.keyboardFocusedName}
                        onFocus={(pipe: (value: any) => void, value, mask: string, id: string) => props.showKeyboard(pipe, value, mask, id)}
                        myleClinicSettings={props.myleClinicSettings}
                    />
                ),
                hideKeyboard
            );
        default:
            return null;
    }
}


// WEBPACK FOOTER //
// ./src/components/PatientOverview/SubComponents/PatientOverviewPopupEdit.tsx